<template>
  <div>
    <span class="d-block text--secondary mb-4">
      {{ $t("message.common.facility") }}
    </span>
    <p class="panel-header__name mb-2">{{ name }}</p>
    <p class="text--secondary mb-1">
      {{ address }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ExpansionPanelHeaderBusinessAddress",
  props: {
    name: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-header__name {
  font-size: 18px;
}
</style>
